import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

export async function getVehicles(params = {}) {
  const { data } = await api.get("/vehicles", { params });
  return data;
}
export async function getVehicleBySlug(slug) {
  const { data } = await api.get(`/vehicles/slug/${slug}`);
  return data;
}
export async function getSimilar(slug) {
  const { data } = await api.get(`/vehicles/similar/${slug}`);
  return data;
}
export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function getQuickEstimate(payload) {
  // payload is forwarded as-is to /api/trade/quick-estimate
  // Expected keys: year, make, model, trim, mileage, condition, body_style,
  // body_subtype, accidents, owners, title_status, tires, service_records,
  // warning_lights, zip_code, features, drivetrain, is_convertible,
  // vin, engine, transmission, cab_type, bed_size, exterior_color,
  // interior_color, interior_material, body_damage, interior_rips_tears,
  // interior_stains, interior_rust, decoded, detected_options,
  // confirmed_options, extra_options, vin_provider, vin_msrp,
  // vin_window_sticker_url, vin_confidence
  const { data } = await api.post("/trade/quick-estimate", payload);
  return data;
}

export async function decodeVin(vin) {
  const { data } = await api.post("/trade/vin-decode", { vin });
  return data;
}

export async function sendChat({ session_id, message, history, page_path, referrer }) {
  const { data } = await api.post("/chat", { session_id, message, history, page_path, referrer });
  return data;
}

export async function chatbotBootstrap(page_path) {
  const { data } = await api.get("/chatbot/bootstrap", { params: { page_path } });
  return data;
}

export async function getAdminStats() {
  const { data } = await api.get("/admin/stats");
  return data;
}
export async function getLeads(leadType) {
  const params = leadType ? { lead_type: leadType } : {};
  const { data } = await api.get("/leads", { params });
  return data;
}
export async function markContacted(id) {
  const { data } = await api.post(`/leads/${id}/mark-contacted`);
  return data;
}
export async function refreshFeed() {
  const { data } = await api.post("/admin/feed/refresh");
  return data;
}
